import o from "react";
import { c as s, t as f } from "./app-a75c1d35.mjs";
import { I as S, W as b } from "./Icon-3122c134.mjs";
const B = "cta-container", D = "cta-content", k = "text", h = "text--white-color", p = "text__disabled-default", N = "text__disabled-default__svg", W = "text__svg-blue-background__svg", I = "text__svg-white-background__svg", t = {
  ctaContainer: B,
  ctaContent: D,
  text: k,
  textWhiteColor: h,
  textDisabledDefault: p,
  textDisabledDefaultSvg: N,
  textSvgBlueBackgroundSvg: W,
  textSvgWhiteBackgroundSvg: I
};
function T(i) {
  const {
    text: r = "Call to Action",
    isDisabled: e,
    showCTAIcon: g = !0,
    isBlueBackground: a,
    containerClassName: x,
    textClassName: u,
    to: n,
    as: d = "a",
    ...v
  } = i;
  let c;
  n && (c = {
    href: n,
    target: "_blank"
  });
  let l = d;
  e && (l = "div");
  const m = s(
    t.ctaContainer,
    x ?? ""
  ), C = s(f.buttonTitle, t.text, {
    textClassName: u,
    [t.textWhiteColor]: a,
    [t.textDisabledDefault]: e,
    [t.textSvgBlueBackgroundSvg]: a
  }), _ = s({
    [t.textDisabledDefaultSvg]: e,
    [t.textSvgBlueBackgroundSvg]: a && !e,
    [t.textSvgWhiteBackgroundSvg]: !a && !e
  });
  return /* @__PURE__ */ o.createElement(
    l,
    {
      className: m,
      "aria-disabled": e,
      ...c,
      ...v
    },
    /* @__PURE__ */ o.createElement("div", { className: t.ctaContent }, /* @__PURE__ */ o.createElement("span", { className: C }, r), g && /* @__PURE__ */ o.createElement(
      S,
      {
        className: _,
        icon: b.ARROW_UP_RIGHT,
        size: 12
      }
    ))
  );
}
export {
  T as C
};
//# sourceMappingURL=CallToAction-d24a74ed.mjs.map
